// Non-secret device values on the web (FR-020, FR-031): localStorage behind the same async API, which
// never throws (private mode or blocked storage reads as empty).
export const deviceStorage = {
  async get(key: string): Promise<string | null> {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  async set(key: string, value: string): Promise<void> {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Unwritable storage only loses a convenience value.
    }
  },
  async remove(key: string): Promise<void> {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // As above.
    }
  },
};
